import {
  startEfficeNavControls,
  stopEfficeNavControls,
} from "helpers/navShortcuts";
import { useEffect } from "react";

const useEfficeNav = () => {
  useEffect(() => {
    startEfficeNavControls();
    return () => stopEfficeNavControls();
  }, []);
};

export default useEfficeNav;
